import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

// Pulled from: https://usehooks-ts.com/react-hook/use-copy-to-clipboard

type CopyFn = (text: string) => Promise<boolean>; // Return success

const useCopyToClipboard = (): CopyFn => {
  const { t } = useTranslation();

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      console.warn(t('clipboard.warning'));
      return false;
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      toast.success(t('clipboard.success'));
      return true;
    } catch (error) {
      console.warn(t('clipboard.failure'), error);
      return false;
    }
  };

  return copy;
};

export default useCopyToClipboard;
